import { Reveal } from "@/components/site/Reveal";

export const SectionHeading = ({
  eyebrow,
  lines,
  align = "left",
  compact = false,
  testId,
}) => (
  <div
    className={align === "center" ? "text-center" : "text-left"}
    data-testid={testId}
  >
    <Reveal>
      <div
        className={`flex items-center gap-4 ${
          align === "center" ? "justify-center" : ""
        }`}
      >
        <span className="h-px w-10 bg-aqua/60" />
        <span className="eyebrow">{eyebrow}</span>
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        className={`display mt-7 text-offwhite ${
          compact
            ? "text-[1.75rem] sm:text-[2.1rem] lg:text-[2.35rem]"
            : "text-3xl sm:text-4xl lg:text-[3.25rem]"
        }`}
      >
        {lines.map((line, i) => (
          <span key={line} className="block">
            {i === lines.length - 1 ? (
              <span className="text-mist/90">{line}</span>
            ) : (
              line
            )}
          </span>
        ))}
      </h2>
    </Reveal>
  </div>
);
